import { render, staticRenderFns } from "./AddArticleToOrderPopup.vue?vue&type=template&id=98e5cbb2"
import script from "./AddArticleToOrderPopup.vue?vue&type=script&lang=ts"
export * from "./AddArticleToOrderPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports